import React from "react";
import { connect } from "react-redux";
import {
  reduxForm,
  formValueSelector,
  change,
  reset,
  submit,
  SubmissionError,
  stopSubmit,
  destroy,
} from "redux-form";
import validate from "./validate";
import PickupFormComponent from "./component";
import {
  nextStep,
  setFormData,
  resetFormData,
  pickupBlocksApi,
} from "../pickup-form.actions";
import { getPickupBlockByType } from "utils/helpers";
import Tracking from "utils/tracking";
import { showToastError } from "../../../helpers";

/*
 *
 * Set Initial Values
 * Set any default values for this form here, they will be passed to redux form
 **/

// import {logout} from 'actions/donor-login.actions'
let initialValues = {};

const thisForm = "publicPickupForm";

const mapStateToProps = (state, ownProps) => {
  const selectForm = formValueSelector(thisForm);
  const props = {
    user: state.donorWizard.formValues.user || null,
    location: state.donorWizard.formValues.location || null,
    pickupBlocks: state.donorWizard.pickupBlocks,
    dropOffLocations: state.donorWizard.dropOffLocations,
    addressSelected: state.donorWizard.formValues.mapAddress || null,
    hasFurniture: selectForm(state, "hasFurniture"),
    zipCode: state.donorWizard.formValues.zipCode || null,
  };

  return { ...initialValues, ...ownProps.initialValues, ...props };
};

const mapDispatchToProps = (dispatch) => {
  const handleSubmit = (form) => (dispatch) =>
    new Promise((resolve, reject) => {
      dispatch(setFormData({ zipCode: form.zipCode }));
      window.scrollTo(0, 0);

      resolve();
    });

  const handleSelect = (address) => (dispatch) => {
    let addressInfo = {
      zipCode: address.zip,
      location: address,
      address: address.fullAddress,
      lat: address.lat,
      lng: address.lng,
    };

    // When a selection is made scroll to the bottom
    window.scrollTo(0, 9999);

    Tracking.track("Step 1: Logged : Existing Location Chosen");

    // Set the data in the multistep form
    dispatch(setFormData(addressInfo));

    dispatch(change(thisForm, "addressInfo", addressInfo));

    // Makes the actual API request who's promise is used for validation in redux-form
    dispatch(
      pickupBlocksApi.get(
        {
          zipCode: addressInfo.zipCode,
          availableStops: true,
          futureEvents: true,
          enabled: true,
          dropOff: true,
          lat: addressInfo.lat,
          lng: addressInfo.lng,
        },
        true
      )
    )
      .then((q) => {
        let pickupBlocks = q.data;

        let hasPickupBlocks = pickupBlocks.length > 0,
          furniturePickupsAvailable =
            getPickupBlockByType(pickupBlocks, "furniture").length > 0,
          standardPickupsAvailable =
            getPickupBlockByType(pickupBlocks).length > 0;

        dispatch(
          stopSubmit(thisForm, {
            warnings: { pickupBlocksAvailable: "true" },
          })
        );
      })
      .catch((err) => {
        dispatch(stopSubmit(thisForm, err.errors));
      });

    dispatch(change(thisForm, "zipCode", addressInfo.zipCode));
  };

  return {
    handleSelect: (location) => dispatch(handleSelect(location)),
    onSubmit: (form) => dispatch(handleSubmit(form)),
    onSubmitSuccess: () => dispatch(nextStep()),
    showAddNewLocation: () => {
      Tracking.track("Step 1: Logged : Add New Location Chosen");
      dispatch(
        resetFormData([
          "zipCode",
          "address",
          "city",
          "state",
          "mapAddress",
          "pickupsAvailable",
          "dropOffLocations",
          "pickupBlocks",
          "location",
        ])
      );
      dispatch(destroy(thisForm));
      dispatch(pickupBlocksApi.reset());
      dispatch(setFormData({ addNewLocation: true }));
    },
  };
};

// Create a component which injects redux form state, also handles handleSubmit of the underlying form component
const withForm = reduxForm({
  form: thisForm,
  destroyOnUnmount: false,
  validate,
})(PickupFormComponent);

// Connect to the store using a container component
const withConnect = connect(mapStateToProps, mapDispatchToProps)(withForm);

// Export Complete wrapper component ( Inject Reducer -> Connect -> Redux-Form -> Component )
export default withConnect;
// export default ()=><div>hi</div>
